import { useState, useEffect, useCallback } from 'react';
import {
  createFactureAchat,
  saveFactureAchat,
  getFactureAchat,
  listFacturesAchat,
  getItemsInFactureAchat,
  validateFactureAchat,
  unvalidateFactureAchat,
} from '../models/achatFactureAPI';

export const useFetchAllFacturesAchat = (params) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchData = useCallback(async () => {
    try { setLoading(true); const res = await listFacturesAchat(params); setItems(res.data.items || []); setTotal(res.data.total || 0); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [params]);
  useEffect(() => { fetchData(); }, [fetchData]);
  return { items, total, loading, error, refetch: fetchData };
};

export const useFetchFactureAchatById = (id) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchOne = useCallback(async () => {
    if (!id) return;
    try { setLoading(true); const res = await getFactureAchat(id); setData(res.data); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [id]);
  useEffect(() => { fetchOne(); }, [fetchOne]);
  return { data, loading, error, refetch: fetchOne };
};

export const useFetchItemsInFactureAchat = (id) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fetchItems = useCallback(async () => {
    if (!id) return;
    try { setLoading(true); const res = await getItemsInFactureAchat(id); setItems(res.data || []); }
    catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, [id]);
  useEffect(() => { fetchItems(); }, [fetchItems]);
  return { items, loading, error, refetch: fetchItems };
};

export const useCreateFactureAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const create = async (payload) => {
    try { setLoading(true); const res = await createFactureAchat(payload); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { create, loading, error };
};

export const useSaveFactureAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const save = async (facture, details) => {
    try { setLoading(true); const res = await saveFactureAchat({ facture, details }); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { save, loading, error };
};

export const useValidateFactureAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const validate = async (id) => {
    try { setLoading(true); const res = await validateFactureAchat(id); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { validate, loading, error };
};

export const useUnvalidateFactureAchat = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const unvalidate = async (id) => {
    try { setLoading(true); const res = await unvalidateFactureAchat(id); return res.data; }
    catch (e) { setError(e.message); throw e; }
    finally { setLoading(false); }
  };
  return { unvalidate, loading, error };
};

